import * as bootstrap from "bootstrap";
import React, { useEffect, useRef } from "react";
import { IoInformationCircle } from "react-icons/io5";

export interface HHelpProps<T> extends React.HTMLAttributes<HTMLOrSVGElement> {
	/** The word "ref" is reserved. We have to use ref2 */
	// ref2?: { current: HTMLSpanElement | null };
	msg: string;
	// onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void,
}

export function HHelp<T>({ msg, ...props }: HHelpProps<T>) {
	function showTooltip() {
		if (ref.current) {
			let inst = bootstrap.Tooltip.getInstance(ref.current);
			if (!inst) {
				inst = new bootstrap.Tooltip(ref.current);
			}
			// inst.setContent({ '.tooltip-inner': 'another title' });
			// inst.show();
		} else {
			console.error("Cannot show tooltip, ref is null");
		}
	}

	function hideTooltip() {
		if (ref.current) {
			let inst = bootstrap.Tooltip.getInstance(ref.current);
			if (inst) {
				inst.dispose();
			}
		}
	}

	const props2 = {
		...props,
		// 'data-bs-toggle': 'tooltip',
		"data-bs-placement": "bottom",
		"data-bs-custom-class": "custom-tooltip",
		"data-bs-title": msg,
	};

	const ref = useRef<HTMLSpanElement>();

	return (
		<span ref={ref as any} {...props2}>
			<IoInformationCircle
				onMouseEnter={showTooltip}
				onMouseLeave={hideTooltip}
				style={{ cursor: "pointer" }}
			/>
		</span>
	);
}
